<!-- <div class="breadcrumb">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a [routerLink]="['/']">Home</a></li>
      <li class="breadcrumb-item active" aria-current="page">Offers</li>
    </ol>
  </nav>
</div> -->
<div class="content-info">
  <div class="content-title d-flex flex-column flex-md-row align-items-md-center justify-content-between">
    <h3 class="title mb-3 mb-md-0">Offers</h3>
    <div class="title-actions d-flex flex-wrap align-items-center gap-2">
      <!-- Search offer input -->
      <div class="form-group mb-0">
        <input type="text" [(ngModel)]="offerSearchTerm" (input)="onSearch()" placeholder="Search offer..."
          class="form-control" style="min-width: 200px;" />
      </div>

      <!-- Filter toggle. Badge shows count of active filters so the
           admin can see at a glance whether the current list is
           narrowed or showing the full catalog. -->
      <button type="button" class="btn btn-outline-secondary text-nowrap" (click)="toggleFilters()">
        <i class="bi bi-funnel"></i> Filters
        @if (activeFilterCount > 0) {
          <span class="badge bg-primary ms-1">{{ activeFilterCount }}</span>
        }
      </button>

      <!-- MRP off list: bulk per-SKU offer prices from Excel -->
      <button type="button" class="btn btn-outline-primary text-nowrap" (click)="openMrpOffUpload()"
        title="Upload a sheet of SKU / MRP / offer price columns">
        <i class="bi bi-file-earmark-arrow-up"></i> Upload MRP Off List
      </button>

      <!-- Add Offer button -->
      <button class="btn btnprimary text-nowrap" [routerLink]="['/create-offer']">
        <i class="bi bi-plus-lg"></i>Add Offer
      </button>
    </div>
  </div>

  <!-- ── Filter bar ───────────────────────────────────────────────────
       Standard ERP retail filter set: store (multi), offer status,
       offer type, and an "active on" date range. All filters combine
       with AND on the backend. Empty fields are simply not sent. -->
  @if (filtersExpanded) {
  <div class="offer-filters card mt-3">
    <div class="card-body">
      <div class="row g-3">
        <div class="col-md-3">
          <label class="form-label small fw-semibold">Store</label>
          <ng-select class="ngselect"
                     [items]="stores"
                     bindLabel="name"
                     bindValue="id"
                     [multiple]="true"
                     [loading]="storesLoading"
                     placeholder="All stores"
                     [(ngModel)]="selectedStoreIds">
          </ng-select>
        </div>
        <div class="col-md-2">
          <label class="form-label small fw-semibold">Status</label>
          <ng-select class="ngselect"
                     [items]="statusOptions"
                     bindLabel="label"
                     bindValue="value"
                     placeholder="Any status"
                     [(ngModel)]="selectedStatus">
          </ng-select>
        </div>
        <div class="col-md-3">
          <label class="form-label small fw-semibold">Offer Type</label>
          <ng-select class="ngselect"
                     [items]="offerTypeOptions"
                     bindLabel="label"
                     bindValue="value"
                     placeholder="Any type"
                     [(ngModel)]="selectedOfferType">
          </ng-select>
        </div>
        <div class="col-md-2">
          <label class="form-label small fw-semibold">Active From</label>
          <input type="date" class="form-control" [(ngModel)]="filterStartDate" />
        </div>
        <div class="col-md-2">
          <label class="form-label small fw-semibold">Active To</label>
          <input type="date" class="form-control" [(ngModel)]="filterEndDate" />
        </div>
      </div>
      <div class="d-flex justify-content-end gap-2 mt-3">
        <button type="button" class="btn btn-link text-decoration-none"
                [disabled]="activeFilterCount === 0"
                (click)="clearFilters()">
          Clear
        </button>
        <button type="button" class="btn btnprimary" (click)="applyFilters()">
          Apply
        </button>
      </div>
    </div>
  </div>
  }

  <div class="common-table">
    <div class="table-responsive">
      <table class="table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Offer Type</th>
            <th>Status</th>
            <th>Start Date</th>
            <th>End Date</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          @if(offersLoading) {
          <tr>
            <td colspan="6" class="text-center">Offers Loading...</td>
          </tr>
          } @else {
          @if(!offers.length) {
          <tr>
            <td colspan="6" class="text-center">No offers found.</td>
          </tr>
          } @else { @for(offer of offers; track offer.id) {
          <tr>
            <td>
              {{ offer.offerName }}
              <!-- Conflict indicator: this offer competes with N others on the
                   loaded page. Hovering the badge explains the resolution rule
                   so the admin knows it's expected ERP behaviour, not a bug. -->
              @if (competingOfferCount(offer) > 0) {
                <span class="badge bg-warning text-dark ms-2"
                      [title]="'Competes with ' + competingOfferCount(offer) + ' other bill offer(s) in overlapping date range. System picks the best per cart automatically.'">
                  <i class="bi bi-exclamation-triangle-fill"></i>
                  competes with {{ competingOfferCount(offer) }}
                </span>
              }
            </td>
            <td>{{ offer.offerType }}</td>
            <td>
              <!-- Derived-status pill. ACTIVE / PAUSED stay clickable (toggle
                   isActive). SCHEDULED / EXPIRED render as informational
                   badges only — clicking is a no-op (see canToggle). -->
              @switch (derivedStatus(offer)) {
                @case ('ACTIVE') {
                  <button type="button"
                          class="btn btn-sm status-pill status-on"
                          [title]="statusTooltip(offer)"
                          (click)="toggleActive(offer, $event)">
                    <i class="bi bi-check-circle-fill me-1"></i> Active
                  </button>
                }
                @case ('PAUSED') {
                  <button type="button"
                          class="btn btn-sm status-pill status-off"
                          [title]="statusTooltip(offer)"
                          (click)="toggleActive(offer, $event)">
                    <i class="bi bi-pause-circle-fill me-1"></i> Paused
                  </button>
                }
                @case ('SCHEDULED') {
                  <span class="status-pill status-scheduled"
                        [title]="statusTooltip(offer)">
                    <i class="bi bi-calendar-event-fill me-1"></i> Scheduled
                  </span>
                }
                @case ('EXPIRED') {
                  <span class="status-pill status-expired"
                        [title]="statusTooltip(offer)">
                    <i class="bi bi-clock-history me-1"></i> Expired
                  </span>
                }
              }
            </td>
            <!-- Offer start/end are stored as date-only values (the modal
                 uses <input type="date">, which JS serialises as midnight
                 UTC). Rendering in the user's local timezone with HH:mm
                 would surface a misleading "05:30 IST" offset — so we
                 display the calendar date only. Time-of-day restrictions
                 live in the separate startTime / endTime fields used by
                 Happy Hour offers. -->
            <td>{{ offer.startDate | date : "dd-MM-yyyy" : "UTC" }}</td>
            <td>{{ offer.endDate | date : "dd-MM-yyyy" : "UTC" }}</td>
            <td>
              <div class="td-actions-btn">
                <button class="btn btn-edit" (click)="openAddOfferDialog(offer)" data-bs-toggle="modal"
                  data-bs-target="#addOffer" title="View / Edit offer">
                  <i class="bi bi-pencil-square"></i>
                </button>
                <button type="button" class="btn btn-trash" data-bs-toggle="modal" data-bs-target="#confirmDeleteModal"
                  (click)="openDeleteConfirmationModal(deleteConfirmationModal, offer)" title="Delete offer">
                  <i class="bi bi-trash3"></i>
                </button>
              </div>
            </td>
          </tr>
          } }
          }

        </tbody>
      </table>
    </div>
    <app-pagination [page]="currentPage" [limit]="pageSize" [total]="total" [pageCount]="pageCount"
      (pageChange)="goToPage($event)" (limitChange)="onPageSizeChange($event)">
    </app-pagination>
  </div>
</div>


<!-- Delete Modal Template -->
<ng-template #deleteConfirmationModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title" id="confirmDeleteModalLabel">Confirm Delete</h5>
    <button type="button" class="btn-close" (click)="closeModal()" aria-label="Close"></button>
  </div>
  <div class="modal-body delete-msg">
    <h3>Are you sure you want to delete <strong>{{ offerToDelete?.offerName }}</strong> offer?</h3>

  </div>
  <div class="modal-footer">
    <button type="button" class="btn btnsecondary" (click)="closeModal()">Cancel</button>
    <button type="button" class="btn btn-danger" (click)="confirmDelete()">Delete</button>
  </div>
</ng-template>


<!-- Pause / activate confirmation for the status pill. -->
<ng-template #toggleStatusModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title" id="toggleStatusModalLabel">
      @if (toggleWillPause) { Pause offer? } @else { Activate offer? }
    </h5>
    <button type="button" class="btn-close" (click)="modal.dismiss()" aria-label="Close"
      [disabled]="toggleInProgress"></button>
  </div>
  <div class="modal-body delete-msg">
    @if (toggleWillPause) {
      <h3>Pause <strong>{{ offerToToggle?.offerName }}</strong>?</h3>
      <p class="text-muted mb-0">
        It will stop applying at every POS on the next sync. You can activate it again later from this list.
      </p>
    } @else {
      <h3>Activate <strong>{{ offerToToggle?.offerName }}</strong>?</h3>
      <p class="text-muted mb-0">
        It will start applying at the POS as soon as the terminals sync, for the whole date range
        {{ offerToToggle?.startDate | date : "dd-MM-yyyy" : "UTC" }} – {{ offerToToggle?.endDate | date : "dd-MM-yyyy" : "UTC" }}.
      </p>
    }
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btnsecondary" (click)="modal.dismiss()" [disabled]="toggleInProgress">Cancel</button>
    <button type="button" class="btn" [class.btn-warning]="toggleWillPause" [class.btn-success]="!toggleWillPause"
      (click)="confirmToggle(modal)" [disabled]="toggleInProgress">
      @if (toggleInProgress) { <span class="spinner-border spinner-border-sm me-1"></span> }
      @if (toggleWillPause) { Pause } @else { Activate }
    </button>
  </div>
</ng-template>

<!-- MRP Off List upload. One sheet of SKU / MRP / offer-price columns →
     one PriceOffOnProduct offer per price column, each SKU at its own
     price. Dry-run preview first; commit is all-or-nothing. -->
<ng-template #mrpOffUploadModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">
      <i class="bi bi-file-earmark-arrow-up me-2"></i>Upload MRP Off List
    </h5>
    <button type="button" class="btn-close" (click)="modal.dismiss()" [disabled]="upload.committing"
      aria-label="Close"></button>
  </div>
  <div class="modal-body">
    <!-- Same sections as the Add Offer form: Basics → Rule (from the
         sheet) → Scope → Conflict resolution. -->
    <div class="offer-status-row mb-3" [class.is-active]="upload.isActive" [class.is-inactive]="!upload.isActive">
      <div class="form-check form-switch mb-0">
        <input class="form-check-input" type="checkbox" role="switch" id="mrpOffActive"
          [(ngModel)]="upload.isActive" (ngModelChange)="onUploadFieldChange()" [disabled]="upload.committing" />
        <label class="form-check-label fw-semibold" for="mrpOffActive">
          @if (upload.isActive) {
            <span class="badge bg-success me-2"><i class="bi bi-check-circle-fill me-1"></i> ACTIVE</span>
            These offers will apply at the POS when the date range is current.
          } @else {
            <span class="badge bg-secondary me-2"><i class="bi bi-pause-circle-fill me-1"></i> INACTIVE</span>
            Offers are created paused — they will NOT apply at the POS until activated.
          }
        </label>
      </div>
    </div>

    <h6 class="text-uppercase small fw-bold text-muted mb-2">1 · Basics</h6>
    <div class="row g-3 mb-3">
      <div class="col-md-4">
        <label class="form-label">Offer Type <span class="text-danger">*</span></label>
        <select class="form-select" [(ngModel)]="upload.offerType" (ngModelChange)="onUploadFieldChange()"
          [disabled]="upload.committing">
          @for (t of uploadOfferTypes; track t.value) {
            <option [ngValue]="t.value">{{ t.label }}</option>
          }
        </select>
        <div class="form-text">{{ uploadTypeMeta.hint }}</div>
      </div>
      <div class="col-md-4">
        <label class="form-label">Offer Name <span class="text-danger">*</span></label>
        <input type="text" class="form-control" [(ngModel)]="upload.offerName" (ngModelChange)="onUploadFieldChange()"
          placeholder="e.g. MRP OFF LIST OCT-2026" [disabled]="upload.committing" />
        <div class="form-text">Store-column offers are named "&lt;name&gt; - &lt;store code&gt;".</div>
      </div>
      <div class="col-md-4">
        <label class="form-label">Description</label>
        <input type="text" class="form-control" [(ngModel)]="upload.description" (ngModelChange)="onUploadFieldChange()"
          placeholder="Internal note — not shown to customer" [disabled]="upload.committing" />
      </div>
      <div class="col-md-3">
        <label class="form-label">Start Date <span class="text-danger">*</span></label>
        <input type="date" class="form-control" [(ngModel)]="upload.startDate" (ngModelChange)="onUploadFieldChange()"
          [disabled]="upload.committing" />
      </div>
      <div class="col-md-3">
        <label class="form-label">End Date <span class="text-danger">*</span></label>
        <input type="date" class="form-control" [(ngModel)]="upload.endDate" (ngModelChange)="onUploadFieldChange()"
          [disabled]="upload.committing" />
      </div>
    </div>

    <h6 class="text-uppercase small fw-bold text-muted mb-2">2 · Offer rule — per-SKU values from the sheet</h6>
    <div class="alert alert-light border small mb-3">
      <div class="d-flex justify-content-between align-items-start gap-3">
        <div>
          Columns: <code>SKU</code>, <code>MRP</code> and one or more
          <code>{{ uploadTypeMeta.valueLabel }} - For All Stores</code> /
          <code>{{ uploadTypeMeta.valueLabel }} - &lt;store code&gt;</code> columns.
          Each value column becomes its own offer. A store column overrides the all-stores value at that store.
          The MRP must match an active MRP of the SKU — the offer applies only to packs carrying that MRP.
        </div>
        <button type="button" class="btn btn-sm btn-outline-secondary text-nowrap flex-shrink-0"
          (click)="downloadMrpOffTemplate()">
          <i class="bi bi-download me-1"></i>Template
        </button>
      </div>
    </div>
    <div class="row g-3 mb-3">
      <div class="col-md-12">
        <label class="form-label">Excel File <span class="text-danger">*</span></label>
        <input type="file" class="form-control" accept=".xlsx,.xls" (change)="onUploadFileChange($event)"
          [disabled]="upload.committing" />
      </div>
    </div>

    <h6 class="text-uppercase small fw-bold text-muted mb-2">3 · Scope</h6>
    <div class="row g-3 mb-3">
      <div class="col-md-12">
        <label class="form-label">Applicable Stores <small class="text-muted">Leave empty to apply at ALL stores</small></label>
        <ng-select class="ngselect" [items]="stores" bindLabel="name" bindValue="id" [multiple]="true"
          [loading]="storesLoading" [disabled]="upload.committing"
          placeholder="Select stores, or leave empty for all"
          [(ngModel)]="upload.storeIds" (ngModelChange)="onUploadFieldChange()">
        </ng-select>
        <div class="form-text">
          The "For All Stores" column is scoped to these stores. Store-specific columns in the sheet must be among them.
          SKUs come from the sheet rows.
        </div>
      </div>
    </div>

    <h6 class="text-uppercase small fw-bold text-muted mb-2">4 · Conflict resolution</h6>
    <div class="row g-3">
      <div class="col-md-3">
        <label class="form-label">Priority <small class="text-muted">(lower number wins)</small></label>
        <input type="number" min="0" step="1" class="form-control" [(ngModel)]="upload.priority"
          (ngModelChange)="onUploadFieldChange()" [disabled]="upload.committing" />
        <div class="form-text">Default 1. A store-specific offer always beats the all-stores one on the same SKU.</div>
      </div>
    </div>

    @if (upload.preview; as p) {
      <hr />
      <div class="d-flex gap-3 mb-3">
        <span class="badge bg-secondary fs-6">{{ p.totalRows }} rows</span>
        <span class="badge bg-success fs-6">{{ p.validRows }} ready</span>
        @if (p.errorRows > 0) {
          <span class="badge bg-danger fs-6">{{ p.errorRows }} with errors</span>
        }
      </div>

      @if (p.offers?.length) {
        <h6 class="fw-semibold">Offers to be created</h6>
        <div class="table-responsive mb-3">
          <table class="table table-sm table-bordered mb-0">
            <thead class="table-light">
              <tr>
                <th>Offer</th>
                <th>Scope</th>
                <th class="text-end">SKUs</th>
                <th>Sample lines</th>
              </tr>
            </thead>
            <tbody>
              @for (o of p.offers; track o.offerName) {
                <tr>
                  <td class="fw-semibold">{{ o.offerName }}</td>
                  <td>
                    @if (o.scope === 'ALL_STORES' && !o.storeNames?.length) {
                      <span class="badge bg-primary">All stores</span>
                    } @else if (o.scope === 'ALL_STORES') {
                      @for (n of o.storeNames; track n) {
                        <span class="badge bg-primary me-1">{{ n }}</span>
                      }
                    } @else {
                      <span class="badge bg-info text-dark">{{ o.storeName }} ({{ o.storeCode }})</span>
                    }
                  </td>
                  <td class="text-end">{{ o.lineCount }}</td>
                  <td class="small text-muted">
                    @for (l of o.sample; track l.sku; let last = $last) {
                      {{ l.sku }} · MRP ₹{{ l.mrp | number:'1.2-2' }} →
                      @if (p.offerType === 'PercentOffOnMRP') { {{ l.value | number:'1.0-2' }}% off } @else { ₹{{ l.value | number:'1.2-2' }} }@if (!last) {<br />}
                    }
                    @if (o.lineCount > o.sample.length) { <br />… and {{ o.lineCount - o.sample.length }} more }
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      }

      @if (p.errors?.length) {
        <div class="alert alert-danger">
          <i class="bi bi-exclamation-octagon-fill"></i>
          <strong>Nothing will be created until every row is fixed.</strong>
          Correct the rows below in your file, then choose it again and preview.
        </div>
        <div class="table-responsive" style="max-height: 260px; overflow-y: auto;">
          <table class="table table-sm table-bordered table-hover mb-0">
            <thead class="table-light">
              <tr>
                <th>Row</th>
                <th>Column</th>
                <th>Error</th>
              </tr>
            </thead>
            <tbody>
              @for (e of p.errors; track $index) {
                <tr>
                  <td class="text-center">{{ e.row > 0 ? e.row : '—' }}</td>
                  <td class="fw-bold">{{ e.column }}</td>
                  <td class="text-danger">{{ e.error }}</td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      }
    }
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btnsecondary" (click)="modal.dismiss()" [disabled]="upload.committing">
      Cancel
    </button>
    <button type="button" class="btn btn-outline-primary" (click)="previewMrpOffUpload()" [disabled]="!canPreviewUpload">
      @if (upload.previewing) { <span class="spinner-border spinner-border-sm me-1"></span> }
      Preview
    </button>
    <button type="button" class="btn btn-success" (click)="confirmMrpOffUpload(modal)" [disabled]="!canCommitUpload">
      @if (upload.committing) { <span class="spinner-border spinner-border-sm me-1"></span> }
      @if (upload.preview?.errors?.length) {
        Fix {{ upload.preview.errorRows }} row(s) to continue
      } @else if (upload.preview?.offers?.length) {
        Create {{ upload.preview.offers.length }} offer{{ upload.preview.offers.length === 1 ? '' : 's' }}
      } @else {
        Create offers
      }
    </button>
  </div>
</ng-template>
